import React, { forwardRef, PropsWithChildren } from "react";

import { Key } from "@multiweb/reactUtils";
import { ForwardRefType } from "@multiweb/types/react";
import { classNames } from "./constants";

export type SectionPanelProps = PropsWithChildren<{
    /** Akce spouštěná po stisknutí klávesy Enter */
    onPrimaryAction?: () => void;
    /** Akce spouštěná po stisknutí klávesy ESC */
    onCancelAction?: () => void;
    /** Zda má být panel focusovatelný a případně jakým způsobem. */
    tabIndex?: number;
}>;

export const SectionPanel: ForwardRefType<HTMLDivElement, SectionPanelProps> = forwardRef<HTMLDivElement, SectionPanelProps>(({
    onPrimaryAction,
    onCancelAction,
    tabIndex,
    children,
}, forwardRef) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === Key.Enter) {
            onPrimaryAction && onPrimaryAction();
        } else if (event.key === Key.Escape) {
            onCancelAction && onCancelAction();
        }
    };

    return (
        <div className={classNames()} ref={forwardRef} {...{ tabIndex }} onKeyDown={handleKeyDown}>
            { children }
        </div>
    );
});
